import ShippingRowOpp from "./ShippingRowOpp";
import ShippingDetailModal from "../modals/shipping/ShippingDetailModal";
import {useEffect, useState} from "react";
import {useAuthStore} from "../../store/auth.store";
import {useOpportunity} from "../../hook/partner/opportunity.partner.hook";
import {useShippingGlsPackingList} from "../../hook/partner/shippping.partner.hook";
import {useOpportunitiesStore} from "../../store/opportunities.store";
import {useShippingsStore} from "../../store/shippings.store";
import {PartnerApi} from "../../api/partner.api";
import Modal from "../modals/Modal";
import { useTranslation } from "../../hooks/useTranslation";

export default function ShippingPackagesTableOpp({opportunity, isInternalAdmin}) {
    const { t } = useTranslation();
    const glsPackingListMutation = useShippingGlsPackingList();

    const token = useAuthStore((state) => state.token);
    const [showShippingDetailModal, setShowShippingDetailModal] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const glsPackagesList = useShippingsStore((state) => state.glsPackagesList);


    useEffect(() => {
        if (token && opportunity) {
            glsPackingListMutation.mutate({
                token,
                id: opportunity.opportunity_id,
            });

        }
    }, [token, opportunity]);

    let packingItemsList = [];
    let packagesGLS = [];

    if (glsPackagesList && "packingItemsList" in glsPackagesList) {
        packingItemsList = glsPackagesList.packingItemsList;
    }

    if (glsPackagesList && "packagesGLS" in glsPackagesList) {
        packagesGLS = glsPackagesList.packagesGLS;
    }

    return (
        <>
            {isInternalAdmin && glsPackagesList && "deliveryInfo" in glsPackagesList && glsPackagesList.deliveryInfo.length > 0 && (
                <>
                    {"moreInfo" in glsPackagesList.deliveryInfo[0][3] && (
                        <Modal title={t("shipping.packageDetail")} show={showModal} handleClose={()=>setShowModal(false)}>
                            <div dangerouslySetInnerHTML={{__html: glsPackagesList.deliveryInfo[0][3].moreInfo}}></div>
                        </Modal>
                    )}

                    <h3 className="mb-4">{t("shipping.title")}</h3>
                    {glsPackagesList.deliveryInfo.map((deliveryInfo) => (
                        <>
                        <div className="delivery-line mb-4">
                            {deliveryInfo[0] != null && "status" in deliveryInfo[0] && (
                                <div className={"delivery-line__item is-" + deliveryInfo[0].status}>
                                    <h2 className="delivery-line__item__title">Exclusive Networks</h2>
                                    <div className="delivery-line__item__icon">
                                        <i className="ki-outline ki-tablet-text-up"></i>
                                    </div>
                                    <div className="delivery-line__item__text">
                                        {deliveryInfo[0].text}
                                    </div>
                                </div>
                            )}

                            {deliveryInfo[1] != null && "status" in deliveryInfo[1] && (
                                <div className={"delivery-line__item is-" + deliveryInfo[1].status}>
                                    <h2 className="delivery-line__item__title">{t("shipping.warehouseTw")}</h2>
                                    <div className="delivery-line__item__icon">
                                        <i className="ki-outline ki-logistic"></i>
                                        <i className="ki-outline ki-arrow-right"></i>
                                    </div>
                                    <div className="delivery-line__item__text">
                                        {deliveryInfo[1].text}
                                    </div>
                                </div>
                            )}

                            {deliveryInfo[2] != null && "status" in deliveryInfo[2] && (
                                <div className={"delivery-line__item is-" + deliveryInfo[2].status}>
                                    <h2 className="delivery-line__item__title">{t("shipping.shippingDhl")}</h2>
                                    <div className="delivery-line__item__icon">
                                        <i className="ki-outline ki-airplane"></i>
                                        <i className="ki-outline ki-arrow-right"></i>
                                    </div>
                                    <div className="delivery-line__item__text">
                                        {deliveryInfo[2].text}
                                    </div>
                                </div>
                            )}

                            {deliveryInfo[3] != null && "status" in deliveryInfo[3] && (
                                <div className={"delivery-line__item is-" + deliveryInfo[3].status}>
                                    <h2 className="delivery-line__item__title">GLS/JL</h2>
                                    <div className="delivery-line__item__icon">
                                        <i className="ki-outline ki-delivery"></i>
                                        <i className="ki-outline ki-arrow-right"></i>
                                    </div>
                                    <div className="delivery-line__item__text">
                                        <a href="javascript:;"
                                           onClick={() => setShowModal(true)}>
                                        {deliveryInfo[3].text}
                                        </a>
                                    </div>
                                </div>
                            )}

                            {deliveryInfo[4] != null && "status" in deliveryInfo[4] && (
                                <div className={"delivery-line__item is-" + deliveryInfo[4].status}>
                                    <h2 className="delivery-line__item__title">{t("shipping.partnerCustomer")}</h2>
                                    <div className="delivery-line__item__icon">
                                        <i className="ki-outline ki-home"></i>
                                        <i className="ki-outline ki-arrow-right"></i>
                                    </div>
                                    <div className="delivery-line__item__text">
                                        <a href="javascript:;"
                                           onClick={() => setShowModal(true)}>
                                        {deliveryInfo[4].text}
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>
                            {deliveryInfo[0] != null && "expected_delivery_date" in deliveryInfo[0] && deliveryInfo[0].expected_delivery_date != ""
                                && deliveryInfo[0].expected_delivery_date != "0000-00-00 00:00:00" && (
                                <div className="delivery-line-expected-delivery-date">
                                    {t("shipping.expectedDeliveryDate")}:&nbsp;
                                    <strong>{new Date(
                                        deliveryInfo[0].expected_delivery_date
                                    ).toLocaleDateString()}</strong>
                                </div>
                            )}
                        </>
                    ))}
                </>
            )}

            {glsPackagesList && "packages" in glsPackagesList && glsPackagesList.packages.length > 0 && (
                <div className="mt-5">
                    {glsPackagesList.hasPackingListPdf ? (
                    <h3 className="mb-4">{t("shipping.deliveredShipments")}</h3>
                        ):(
                        <h3 className="mb-4">{t("shipping.preparedShipments")}</h3>
                    )}

                    {glsPackagesList.hasPackingListPdf && (
                        <button
                            className="btn btn-success mb-4 me-4"
                            onClick={() =>
                                PartnerApi.glsPackagesListPDF({
                                    token,
                                    id: opportunity.opportunity_id,
                                })
                            }
                        >
                            <i className="ki-duotone ki-document fs-4 cursor-pointer">
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>{" "}
                            {t("shipping.exportPdf")}
                        </button>
                    )}

                    {glsPackagesList.hasDeliveryListPdf && (
                        <button
                            className="btn btn-success mb-4"
                            onClick={() =>
                                PartnerApi.glsDeliveryListPDF({
                                    token,
                                    id: opportunity.opportunity_id,
                                })
                            }
                        >
                            <i className="ki-duotone ki-document fs-4 cursor-pointer">
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>{" "}
                            {t("shipping.deliveryNotePdf")}
                        </button>
                    )}

                    <div className="row">
                        {glsPackagesList.packages.map((balik) => (
                            <div className="col-md-4 mb-4">
                                <div className="card h-100">
                                    <div className="card-header">
                                        <h4 className="card-title">
                                            {balik.balik_interni_id}
                                        </h4>
                                    </div>
                                    <div className="card-body">
                                        {packingItemsList && packingItemsList.filter((p) => p.balik_id === balik.balik_id).length > 0 ? (
                                            Array.from(
                                                new Map(
                                                    packingItemsList
                                                        .filter((p) => p.balik_id === balik.balik_id)
                                                        .map((item) => [
                                                            item.polozka_id,
                                                            {
                                                                ...item,
                                                                sn: packingItemsList
                                                                    .filter((p) => p.polozka_id === item.polozka_id && p.balik_id === balik.balik_id)
                                                                    .map((i) => i.sn).length
                                                                    ? packingItemsList
                                                                        .filter(
                                                                            (p) => p.polozka_id === item.polozka_id && p.balik_id === balik.balik_id
                                                                        )
                                                                        .map((i) => i.sn)
                                                                    : [null],
                                                            },
                                                        ])
                                                ).values()
                                            ).map((polozka) => (
                                                <div>
                                                    {polozka.rada}, {polozka.typ}, {polozka.vyrobek}{" "}
                                                    <span className="badge badge-warning">{polozka.sku}</span>
                                                    <div className="mt-3">
                                                        {polozka.sn && polozka.sn.length > 0 && polozka.sn[0] !== null && typeof polozka.sn[0] != "undefined" ? (
                                                            polozka.sn.map((sn) => (
                                                                <span
                                                                    className="badge badge-secondary btn-sm me-2 mb-2">{sn}</span>
                                                            ))
                                                        ) : (
                                                            <span
                                                                className="badge badge-secondary btn-sm">{polozka.pocet_zabaleno} ks</span>
                                                        )}
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="alert alert-danger">{t("shipping.emptyShipment")}</div>
                                        )}
                                    </div>
                                    <div className="card-footer">
                                        {balik.trackingId && (
                                            <>
                                                <strong>GLS:</strong>{" "}
                                                {balik.trackingId}
                                            </>
                                        )}


                                        {packagesGLS.map(packageGls => (
                                            balik.trackingId == packageGls.trackingId &&
                                            packageGls.hasPdfPod == 1 && (
                                                <>
                                                    <br/><br/>

                                                    <button
                                                        className="btn btn-success btn-sm mb-4 me-4"
                                                        onClick={() =>
                                                            PartnerApi.glsPackagePodPDF({
                                                                token,
                                                                trackingId: balik.trackingId,
                                                                id: opportunity.opportunity_id,
                                                            })
                                                        }
                                                    >
                                                        <i className="ki-duotone ki-document fs-4 cursor-pointer">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>{" "}
                                                        {t("shipping.confirmationPdf")}
                                                    </button>
                                                </>
                                            )
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
}
